export const ACTION_STATUS = {
    SUCCES: 1,
    FAILURE: 999
}

export const ACTIONS = {
    WEB_SOCKET_ONOPEN: 1,
    ORDER_TABLE_INIT: 11,
    ORDER_TABLE_URL: 12,
    ORDER_TABLE_DATA_RECEIVED: 12
}

export const TIMER_ACTIONS = {
    START_TIMER: 1,
    STOP_TIMER: 2,
    PAUSE_TIMER: 3,
}

export const WEBSOCKET_STATUS = {

}